import React from 'react';
import { makeStyles, Hidden } from '@material-ui/core';

import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import militaryTech from '../../assets/imgs/military_tech.svg';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    // alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexGrow: 1,
      justifyContent: 'space-between',
    },
  },
  militaryIcon: {
    width: 60,
    [theme.breakpoints.down('sm')]: {
      width: 40,
      alignSelf: 'flex-end'
    },
  },
  icon: {
    fontSize: 36,
    color: theme.palette.auxiliary.green.light,
  },
  boxPoints: {
    paddingLeft: 60,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(5.2)
    },
  },
  pointsText: {
    fontSize: 14,
    color: theme.palette.neutrals.low.light,
    fontWeight: 600,
    textAlign: 'right',
  },
  pointsNumber: {
    fontSize: 31.25,
    color: theme.palette.neutrals.low.main,
    fontWeight: 'bold',
  },
}));

function RankingInfo({ points, placing }) {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <div style={{display: 'flex'}}>
      <div style={{alignSelf: 'flex-end'}}>
        <img src={militaryTech} alt="placing"className={classes.militaryIcon} />
      </div>
      <div className={classes.header}>
        <div className={classes.boxPoints}>
          <div className={classes.pointsText}>{t('colocacao')}</div>
          <div className={classes.pointsNumber}>{parseInt(placing) || 0}º {t('lugar')}</div>
        </div>
        <Hidden smDown>
          <div style={{ marginLeft: 130, alignSelf: 'center' }}>
            <AccountBalanceWalletIcon className={classes.icon} />
          </div>
          <div style={{ marginLeft: 80 }}>
            <div className={classes.pointsText}>{t('pontos').toLowerCase()}</div>
            <div className={classes.pointsNumber}>{parseInt(points) || 0}</div>
          </div>
        </Hidden>
        <Hidden smUp>
          <div>
            <div className={classes.pointsText}>{t('pontos').toLowerCase()}</div>
            <div className={classes.pointsNumber}>{parseInt(points) || 0}</div>
          </div>
        </Hidden>
      </div>

    </div>
  );
}

export { RankingInfo };
